module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/221-tuvalu-3e38f65bc2bd0ac2afccbe9665e6e1f9.svg";